const ROW2Mapping: Record<string, string> = {
    PlanningSystem: '/ROW2/#/Agenda',
    PlacerList: '/ROW2/#/PlacerList',
    GeneralSettings: '/ROW2/#/GeneralSettings',
    exportFormats: '/ROW2/#/ExportFormats',
};

export default ROW2Mapping;
